import AppLifecycle from '../utils/app-lifecycle'

AppLifecycle.ready(function() {
  if (!AppLifecycle.serveTrackingTags()) return
  // Send data to Posthog via analytics.js

  const html = document.querySelector('html')
  const userID = html.getAttribute('data-user-id')
  const userIDHash = html.getAttribute('data-user-hashid')
  const userUsername = html.getAttribute('data-user-username')
  const userEmail = html.getAttribute('data-user-email')
  const userName = html.getAttribute('data-user-name')
  if (userID !== 'None') {
    posthog.identify(
      userID,
      { email: userEmail, name: userName }
    )
  } else {
    posthog.reset()
  }
})
